import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { ToastService } from '@services/toast.service';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { tablerAlertCircle, tablerCircleCheck } from '@ng-icons/tabler-icons';

@Component({
  selector: 'app-toast',
  imports: [AsyncPipe, TranslocoModule, NgIcon],
  providers: [provideIcons({ tablerAlertCircle, tablerCircleCheck })],
  template: `
    <div class="toast toast-end toast-top z-[9999]" role="status" aria-live="polite">
      @for (toast of toastService.toasts$ | async; track toast.id) {
        <div class="alert alert-soft" [class.alert-success]="toast.type === 'success'" [class.alert-error]="toast.type === 'error'"
          [attr.role]="toast.type === 'error' ? 'alert' : null">
          <ng-icon [name]="toast.type === 'error' ? 'tablerAlertCircle' : 'tablerCircleCheck'" size="20" aria-hidden="true" />
          <span>{{ toast.messageKey | transloco }}</span>
        </div>
      }
    </div>
  `,
})
export class ToastComponent {
  toastService = inject(ToastService);
}
